/*
 * @developerName: 邓科峰
 * @Function name:
 * @Date: 2025-12-09 10:01:12
 * @param:
 * @LastEditor:
 * @LastData:
 * @Describe:
 */
// api/request.js
import axios from 'axios'

// 创建 axios 实例
const request = axios.create({
  baseURL: 'https://white.leku666.cn', // API 基础路径
  timeout: 5000 // 请求超时时间
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么

    // 处理 GET 请求参数
    if (config.method === 'get' && config.params) {
      // GET 参数已经在 params 中，axios 会自动处理
    } else if (config.method === 'post') {
      // 如果指定了使用 form-data
      if (config.isFormData && config.data) {
        const formData = new FormData()

        // 处理 type 参数和其他数据
        // if (config.url.includes('?type=')) {
        //   const urlType = config.url.split('?type=')[1].split('&')[0]
        //   formData.append('type', urlType)
        //   // 移除URL中的type参数，避免重复
        //   config.url = config.url.replace(`?type=${urlType}`, '')
        // }

        // 添加其他数据到 form-data
        Object.keys(config.data).forEach(key => {
          formData.append(key, config.data[key])
        })

        config.data = formData
        // 删除 Content-Type，让浏览器自动设置为 multipart/form-data
        delete config.headers['Content-Type']
      } else if (config.data) {
        // 如果URL中有type参数，提取并放入data中
        if (config.url.includes('?type=')) {
          const urlType = config.url.split('?type=')[1].split('&')[0]
          config.data.type = urlType
          // 移除URL中的type参数
          config.url = config.url.replace(`?type=${urlType}`, '')
        }
        config.headers = {
          ...config.headers,
          'Content-Type': 'application/json'
        }
      }
    }

    // 例如添加 token
    // const token = localStorage.getItem('token')
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`
    // }
    return config
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    const res = response

    // 根据实际业务处理响应
    if (res) {
      return res.data
    } else {
      // 处理错误状态
      return Promise.reject(new Error(res.message || 'Error'))
    }
  },
  error => {
    // 对响应错误做点什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

export default request



// WEBPACK FOOTER //
// ./src/utils/axios.js